import { Services } from "appworks/services/services";
import { Exit } from "appworks/state-machine/data/exit";
import { Decision } from "appworks/state-machine/decisions/decision";
import { AutoplayService } from "slotworks/services/autoplay/autoplay-service";

export class IsAutoplayDecision extends Decision {
    public evaluate() {
        return Services.get(AutoplayService).isAutoPlaying() ? Exit.True : Exit.False;
    }
}
